<script>
require("@/assets/js/check-dev");
import zIndex from "@/config/zIndex";

export default {
  name: "App",
  metaInfo: {
    title: "",
    titleTemplate: "【ホームズ】 %s。賃貸マンション住宅情報の3D間取りビューワ"
  },
  computed: {
    classnames() {
      const { state } = this.$store;

      return {
        pc: !state.isMobile,
        mobile: state.isMobile,
        portrait: !state.isLandscape,
        landscape: state.isLandscape
      };
    },
    isCursorPointer() {
      const { state } = this.$store;
      return state.isCursorPointer;
    }
  },
  mounted() {
    const { state } = this.$store;

    // append canvas and add styles to it.
    this.$el.append(state.webgl.canvas);
    state.webgl.canvas.style = `
      position: absolute;
      top: 0;
      left: 0;
      z-index: ${zIndex.canvas}
    `;
  }
};
</script>

<template lang="pug">
#app(
  el = 'app'
  :class = 'classnames'
  )
  .content(
    :class="{ isHover: isCursorPointer }"
    )
    router-view
</template>

<style lang="scss">
@import "@/assets/scss/foundation/normalize.scss";
@import "@/assets/scss/foundation/global.scss";

@import "@/assets/scss/utility/ff.scss";

body {
  @include l-mobile {
    overflow: hidden;
  }
}
#app {
  width: 100%;
  height: 100%;
  position: absolute;
}
.content {
  height: 100%;
  position: relative;
  &.isHover {
    + canvas {
      cursor: pointer;
    }
  }
}
</style>
